<template>
<!--
    基础图片展示组件
    包括单个图片、视频的展示样式及多个图片、视频的展示样式
-->
    <div :class="['dap-image-wrap', 'hand', sizeClass]" :style="containerSizeStyle" @click="handleClick"
        @mouseenter="mouseenterChange" @mouseleave="mouseleaveChange">
        <!-- 多个视频和图片 -->
        <div v-if="isGroup" class="dap-image-group-content">
            <div
                class="dap-image-group-item"
                v-for="(item, $i) in group.coverUrlList" :style="groupItemSizeStyle" :key="$i"
                @click.stop="handleClickGroupItem(item, $i)">
                <div class="dap-image-background">
                    <img :src="item.coverUrl" alt="">
                </div>
                <div class="dap-image-content">
                    <img :src="item.coverUrl" alt="">
                    <DapIconSvg
                        v-if="item.type === 'video'"
                        class="video-player"
                        :style="groupVideoPlayerSizeStyle"
                        icon-class="play">
                    </DapIconSvg>
                </div>
            </div>
        </div>
        <!-- 单个视频和图片 -->
        <div v-else class="dap-image-image-content">
            <div class="dap-image-background">
                <img :src="coverUrl" alt="">
            </div>
            <div class="dap-image-content">
                <img :src="coverUrl" alt="">
                <DapIconSvg
                    v-if="isVideo"
                    class="video-player"
                    :style="videoPlayerSizeStyle"
                    icon-class="play"
                    @click.native.stop="handleClickVideoPlayer">
                </DapIconSvg>
            </div>
        </div>

        <!-- 播放器 -->
        <div class="play-con" v-if="type !== 'image' && autoPlay.isPlay && showPlay">
            <video
                muted
                autoplay
                width="100%"
                height="100%"
                :src="autoPlay.playUrl">
                您的浏览器不支持视频播放，请升级更高版本或者更换浏览器
            </video>
            <div class="play-model"></div>
        </div>
    </div>
</template>

<script>
import DapIconSvg from "../../icon-svg";

const sizeConstantMap = {
    default: {
        class: 'size-default',
        group: {},
    },
    small: {
        class: 'size-small',
        width: '96px',
        height: '54px',
        videoPlayerSize: 20,
        group: {
            groupVideoPlayerSize: 10,
            groupGutter: { horizontal: 4, vertical: 2 }
        },
    },
};

const defaultGroup = {
    coverUrlList: [],
    groupVideoPlayerSize: 20,
    groupGutter: { horizontal: 5, vertical: 3 },
};

export default {
    name: 'DapImage',
    components: { DapIconSvg },
    props: {
        type: {
            type: String,
            default: 'image',
            //可选值：image/video/group
        },
        size: {
            type: String,
            default: 'default',
            //可选值：default/small
        },
        width: {
            type: String,
            default: '208px',
        },
        height: {
            type: String,
            default: '117px',
        },
        coverUrl: {
            type: String,
            default: '',
        },
        videoPlayerSize: {
            type: Number,
            default: 32,
        },
        group: {
            type: Object,
            default: () => (defaultGroup),
        },
        autoPlay: {
            type: Object,
            default: () => ({
                isPlay: false,
                playUrl: ''
            }),
        },
    },
    computed: {
        isGroup () {
            return this.type === 'group';
        },
        isVideo () {
            return this.type === 'video';
        },
        sizeClass () {
            return sizeConstantMap[this.size].class;
        },
        sizeConstantObj () {
            return sizeConstantMap[this.size];
        },
        videoPlayerSizeStyle () {
            const videoPlayerSize = this.sizeConstantObj.videoPlayerSize || this.videoPlayerSize;
            return { width: `${videoPlayerSize}px`, height: `${videoPlayerSize}px` };
        },
        containerSizeStyle () {
            const width = this.sizeConstantObj.width || this.width;
            const height = this.sizeConstantObj.height || this.height;
            return { width, height };
        },
        groupVideoPlayerSizeStyle () {
            const groupVideoPlayerSize = this.sizeConstantObj.group.groupVideoPlayerSize || this.group.groupVideoPlayerSize || defaultGroup.groupVideoPlayerSize;
            return { width: `${groupVideoPlayerSize}px`, height: `${groupVideoPlayerSize}px` };
        },
        groupItemSizeStyle () {
            const groupGutter = this.sizeConstantObj.group.groupGutter || this.group.groupGutter || defaultGroup.groupGutter;
            return {
                margin: `${groupGutter.vertical}px ${groupGutter.horizontal}px`,
                width: `calc(50% - ${groupGutter.horizontal * 2}px)`,
                height: `calc(50% - ${groupGutter.vertical * 2}px)`,
            };
        },
    },

    data () {
        return {
            showPlay: false
        }
    },
    methods: {
        handleClick () {
            this.$emit('click');
        },

        handleClickVideoPlayer () {
            if (this.$listeners.clickVideoPlayer) {
                this.$emit('clickVideoPlayer');
            } else {
                this.$emit('click');
            }
        },

        handleClickGroupItem (item, index) {
            if (this.$listeners.clickGroupItem) {
                this.$emit('clickGroupItem', item, index);
            } else {
                this.$emit('click');
            }
        },

        mouseenterChange () {
            this.showPlay = true;
        },

        mouseleaveChange () {
            this.showPlay = false;
        }
    }
};
</script>

<style lang="scss">
.dap-image-wrap {
    position: relative;
    .dap-image-image-content {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        background-color: #000;
        overflow: hidden;
        position: relative;
    }

    .dap-image-group-content {
        width: 100%;
        height: 100%;
        overflow: auto;

        .dap-image-group-item {
            float: left;
            overflow: hidden;
            position: relative;
            border-radius: 2px;
        }
    }

    .dap-image-background {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        display: flex;
        align-items: center;

        img {
            vertical-align: middle;
            filter: blur(2.5px);
            height: 100%;
            width: 100%;
        }
    }

    .dap-image-content {
        background-color: rgba(0, 0, 0, 0.45);
        display: flex;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        -webkit-box-pack: center;
        align-items: center;
        justify-content: center;
        text-align: center;

        img {
            max-width: 100%;
            max-height: 100%;
            vertical-align: bottom;
            border: 0;
        }
    }

    .video-player {
        transform: translateX(-50%) translateY(-50%);
        position: absolute;
        left: 50%;
        top: 50%;
    }

    &.size-small {
        .dap-image-group-content {
            padding: 0;
        }
    }

    .play-con{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        video{
            position: absolute;
            z-index: 2
        }
        .play-model{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0);
            z-index: 1
        }
    }
}
</style>
